<template>
  <div :class="$style.footer">
    <div :class="$style.infoWrapper">
      <div :class="$style.info">
        <div :class="$style.logoWrapper">
          <img :class="$style.logo" :src="logo">
        </div>
        <div :class="$style.line"></div>
        <div :class="$style.contact">
          <div :class="$style.phone">联系电话: 400-616-6206</div>
          <div :class="$style.email">电子邮箱: hezuo@geekbang.com </div>
        </div>
        <div :class="$style.line"></div>
        <div :class="$style.abount">
          <div :class="$style.follow">
            <img :class="$style.qrcode" :src="publicImg">
            <div :class="$style.desc">关注公众号<br>后台留言</div>
            <div :class="$style.bigQrcodeWrapper">
              <img :class="$style.bigQrcode" :src="publicImg">
            </div>
          </div>
          <div :class="$style.follow">
            <img :class="$style.qrcode" :src="shipinhaoImg">
            <div :class="$style.desc">关注极客邦 CEO<br>“霍太稳”视频号</div>
            <div :class="$style.bigQrcodeWrapper">
              <img :class="$style.bigQrcode" :src="shipinhaoImg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.copyright">
      <p>
        Copyright © {{ new Date().getFullYear() }} The Holding of GeekBang (Beijing) Co, Ltd. 极客邦控股(北京)有限公司 |
        <a href="https://beian.miit.gov.cn" target="_blank">京 ICP 备 16027448号-{{ topDomain === 'com' ? '4' : '3' }}.</a>
      </p>
      <p :class="$style.beian">
        <img :class="$style.policeImg" src="https://static001.geekbang.org/static/time/img/geek_elements/beian.png">
        <a :class="$style.police" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037384" target="_blank">
          京公网安备 110105020{{ topDomain === 'com' ? '57106' : '37384' }} 号
        </a>
        <a href="https://time.geekbang.org/hybrid/certificates" target="_blank">产品资质</a>
        <!-- <a class="net" href="https://static001.geekbang.org/resource/image/ab/7b/ab0fad9c05fc91d5b1819da6d449137b.jpg" target="_blank">京网文[2019]6009-706号</a> -->
      </p>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/img/logo/logo-white.png'
import publicImg from '@/assets/img/footer/public.png'
import shipinhaoImg from '@/assets/img/footer/shipinhao.png'

import { topDomain } from '@/config'

export default {
  data () {
    return {
      logo,
      publicImg,
      shipinhaoImg,

      topDomain
    }
  }
}
</script>

<style lang="scss" module>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 1200px;
  height: 100px;
}

.infoWrapper {
  // height: 88px;
  background: #333333;
}

.info {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin: 0 auto;
  width: 1200px;
  height: 88px;
  padding: 16px 0 16px 93px;
}

.logo {
  height: 44px;
}

.line {
  margin: 0 80px;
  width: 1px;
  height: 44px;
  background: rgba(136, 136, 136, .5);
}

.contact {
  line-height: 28px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
}

.email {
  white-space: nowrap;
}

.abount {
  display: flex;
}

.follow {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;

  &:hover {
    .bigQrcodeWrapper {
      visibility: visible;
    }
  }
}

.qrcode {
  margin-right: 8px;
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 4px;
}

.desc {
  font-size: 14px;
  color: #fff;
  line-height: 20px;
}

.bigQrcodeWrapper {
  visibility: hidden;
  position: absolute;
  left: 0;
  bottom: 60px;
  width: 108px;
  height: 108px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px rgba(239,182,162,0.36);
  border-radius: 5px;

  &:after {
    content: "";
    position: absolute;
    left: 11px;
    bottom: -4px;
    width: 8px;
    height: 8px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(239,182,162,0.36);
    border-radius: 2px;
    transform: rotate(45deg);
  }

  .bigQrcode {
    position: relative;
    z-index: 10;
    width: 94px;
    height: 94px;
  }
}

.copyright {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 16px;
  padding-left: 56px;
  height: 88px;
  line-height: 28px;
  background: linear-gradient(180deg, #FFFBF7 0%, #FBF9F5 100%);
  font-size: 14px;
  font-weight: 400;
  color: #888888;
}

.beian {
  display: flex;
  align-items: center;

  a {
    margin-right: 10px;
  }
}

.policeImg {
  margin-right: 3px;
  width: 14px;
  height: 14px;
}
</style>
